import { render, staticRenderFns } from "./search.vue?vue&type=template&id=1cee70f4"
import script from "./search.ts?vue&type=script&lang=js&external"
export * from "./search.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cee70f4')) {
      api.createRecord('1cee70f4', component.options)
    } else {
      api.reload('1cee70f4', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=1cee70f4", function () {
      api.rerender('1cee70f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/searchCombo/search.vue"
export default component.exports